/**
 * Application Configuration
 * All environment variables should be accessed through this config object
 */

// Helper to ensure URL has trailing slash
const ensureTrailingSlash = (url) => url?.endsWith('/') ? url : `${url}/`;

const config = {
  // API Configuration
  apiBaseUrl: ensureTrailingSlash(process.env.REACT_APP_BASE_API_URL || 'http://localhost:8081'),
  ecoprismApiUrl: ensureTrailingSlash(process.env.REACT_APP_ECOPRISM_API_URL || 'http://localhost:8081'),

  // Auth0 Configuration
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-bzvpxk64kwf4dxfs.us.auth0.com',
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '7cbSk1OzSn3wLKHfN6UlmpdT95NuFo7r',
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://dev-bzvpxk64kwf4dxfs.us.auth0.com/api/v2/',
  },

  // Azure AD Configuration
  azure: {
    authority: process.env.REACT_APP_AZURE_AUTHORITY || 'https://login.microsoftonline.com/organizations',
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '44d65616-9482-4ea2-b9f3-c6c5b62224f7',
    // Derive redirect/logout from the RUNTIME origin so they always match the host
    // the app is actually served from (localhost, dev, prod). CRA bakes REACT_APP_*
    // at build time, so a hardcoded localhost fallback would otherwise ship in any
    // build made without these env vars set.
    redirectUri:
      process.env.REACT_APP_PORTAL_REDIRECT_URI ||
      (typeof window !== 'undefined' ? `${window.location.origin}/callback` : '/callback'),
    logoutUri:
      process.env.REACT_APP_PORTAL_LOGOUT_URI ||
      (typeof window !== 'undefined' ? `${window.location.origin}/login` : '/login'),
  },

  // PowerBI Configuration
  powerBi: {
    apiUrl: process.env.REACT_APP_POWERBI_API_URL || 'https://powerbi-dev-embedded.azurewebsites.net/api/HttpTrigger1',
  },

  // Application Insights
  appInsights: {
    instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY || '',
  },

  // Where people are pointed when sign-in is refused or something needs a human.
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@ecoprism.com',
};

export default config;
